import styled from "styled-components";

export const Duvidas = styled.section`
  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 43px;
    gap: 40px;
    margin: 0 auto;

    #duvidas-img {
      figure {
        width: 100%;

        img {
          width: 100%;
        }
      }
    }

    #duvidas-text {
      display: flex;
      flex-direction: column;
      gap: 48px;

      #duv-one {
        display: flex;
        flex-direction: column;
        gap: 10px;

        span {
          font-weight: 700;
          font-size: 12px;
          line-height: 122%;
          text-transform: uppercase;
          color: var(--orange);
        }

        h1 {
          font-weight: 700;
          font-size: 24px;
          line-height: 122%;
          color: var(--title);
        }
      }

      #duv-two {
        display: flex;
        flex-direction: column;
        gap: 40px;

        .aulas {
          display: flex;
          flex-direction: column;
          gap: 18px;

          h3 {
            font-weight: 700;
            font-size: 14px;
            line-height: 160%;
            color: var(--paragraph);
          }

          p {
            font-weight: 400;
            font-size: 14px;
            line-height: 160%;
            color: var(--paragraph);
          }

          button {
            background: var(--orange);
            color: var(--white);

            border: 1.38182px solid #f6916b;
            border-radius: 1.5px;
            width: 100%;
            max-width: 600px;
            height: 92px;

            font-weight: 700;
            font-size: 20px;
            line-height: 140%;
            text-align: center;
            text-transform: uppercase;

            cursor: default;

            span {
              font-weight: 500;
              font-size: 16px;
              line-height: 140%;
              text-transform: none;

              color: var(--white);
            }
          }
        }
      }
    }
  }

  @media (min-width: 601px) {
    #pather-div {
      flex-direction: row;

      #duvidas-img {
        figure {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;

            img {
                width: 140%;
            }
        }
      }

      #duvidas-text {
        #duv-one {
          span {
            font-size: 16px;
          }

          h1 {
            font-size: 40px;
          }
        }

        #duv-two {
          .aulas {
            h3 {
              font-size: 20px;
            }

            p {
              font-size: 16px;
            }

            button {
              font-size: 30px;

              span {
                font-size: 20px;
              }
            }
          }
        }
      }
    }
  }
`;
